module.exports = __webpack_public_path__ + "img/kc.5f3db8c1.png";